/* ============================================================
   BUMBERA'S PERFORMANCE — theme.js (prototype)
   Everything here has a direct Shopify equivalent noted inline.
   ============================================================ */
(function(){
'use strict';
var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var ROOT = document.documentElement.getAttribute('data-root') || './';
var $ = function(s,c){ return (c||document).querySelector(s); };
var $$ = function(s,c){ return [].slice.call((c||document).querySelectorAll(s)); };
var money = function(n){ return '$' + (Math.round(n*100)/100).toFixed(2); };

/* ---------- year ---------- */
$$('[data-year]').forEach(function(el){ el.textContent = new Date().getFullYear(); });

/* ---------- nav condense ---------- */
var nav = $('#nav');
if(nav){
  var onScroll = function(){ nav.classList.toggle('is-stuck', window.scrollY > 12); };
  onScroll(); window.addEventListener('scroll', onScroll, {passive:true});
  var setTop = function(){
    var r = nav.getBoundingClientRect();
    document.documentElement.style.setProperty('--nav-top', (r.bottom) + 'px');
  };
  setTop(); window.addEventListener('resize', setTop); window.addEventListener('scroll', setTop, {passive:true});
}

/* ---------- mobile menu ---------- */
var burger = $('#burger'), links = $('#navlinks');
if(burger && links){
  burger.addEventListener('click', function(){
    var open = burger.getAttribute('aria-expanded') === 'true';
    burger.setAttribute('aria-expanded', String(!open));
    links.classList.toggle('is-open', !open);
    document.body.style.overflow = !open ? 'hidden' : '';
  });
  links.addEventListener('click', function(e){
    if(e.target.closest('a') && window.innerWidth <= 1080){
      burger.setAttribute('aria-expanded','false');
      links.classList.remove('is-open'); document.body.style.overflow='';
    }
  });
}

/* ---------- dropdowns (hover desktop / tap mobile) ---------- */
$$('.nav__dd').forEach(function(dd){
  var btn = dd.querySelector(':scope > button');
  btn.addEventListener('click', function(e){
    e.stopPropagation();
    var open = dd.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(open));
    $$('.nav__dd').forEach(function(o){ if(o!==dd){ o.classList.remove('is-open'); o.querySelector(':scope > button').setAttribute('aria-expanded','false'); } });
  });
});
document.addEventListener('click', function(e){
  if(!e.target.closest('.nav__dd')) $$('.nav__dd').forEach(function(dd){ dd.classList.remove('is-open'); dd.querySelector(':scope > button').setAttribute('aria-expanded','false'); });
});
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){
    $$('.nav__dd').forEach(function(dd){ dd.classList.remove('is-open'); dd.querySelector(':scope > button').setAttribute('aria-expanded','false'); });
    if(links && links.classList.contains('is-open')){ links.classList.remove('is-open'); burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; burger.focus(); }
    closeCart(); closeSearch();
  }
});

/* ---------- HERO cross-fade ---------- */
var slides = $$('[data-s]');
var dotsWrap = $('#dots');
if(slides.length && dotsWrap){
  var cur = 0, timer = null, DUR = 5600;
  var dots = $$('button', dotsWrap);
  dots.forEach(function(b,i){ b.addEventListener('click', function(){ go(i); restart(); }); });
  function go(n){
    slides[cur].classList.remove('is-live'); dots[cur].setAttribute('aria-current','false');
    cur = (n + slides.length) % slides.length;
    var s = slides[cur]; s.classList.remove('is-live'); void s.offsetWidth; s.classList.add('is-live');
    dots[cur].setAttribute('aria-current','true');
  }
  function restart(){ if(timer) clearInterval(timer); if(!RM) timer = setInterval(function(){ go(cur+1); }, DUR); }
  if(slides.length > 1) restart();
  document.addEventListener('visibilitychange', function(){ if(document.hidden){ if(timer) clearInterval(timer); } else { restart(); } });
}

/* ---------- reveal on scroll ---------- */
var io = null;
function reveal(el){ el.classList.add('in'); if(io) io.unobserve(el); }
function sweep(){
  var vh = window.innerHeight || document.documentElement.clientHeight;
  $$('[data-rv]:not(.in)').forEach(function(el){ if(el.getBoundingClientRect().top < vh * 0.94) reveal(el); });
}
if('IntersectionObserver' in window && !RM){
  io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting || en.boundingClientRect.top < 0) reveal(en.target); });
  }, {rootMargin:'0px 0px -6% 0px', threshold:.04});
  $$('[data-rv]').forEach(function(el){ io.observe(el); });
  window.addEventListener('scroll', sweep, {passive:true}); window.addEventListener('resize', sweep); window.addEventListener('load', sweep); sweep();
} else { $$('[data-rv]').forEach(function(el){ el.classList.add('in'); }); }
setTimeout(function(){ $$('[data-rv]:not(.in)').forEach(function(el){ if(el.getBoundingClientRect().top < (window.innerHeight || 800) * 1.6) reveal(el); }); }, 2200);

/* ---------- counters ---------- */
$$('[data-counters]').forEach(function(rail){
  function run(){
    $$('[data-count]', rail).forEach(function(el, i){
      var target = parseInt(el.getAttribute('data-count'), 10), t0 = null, dur = 1500 + i*160;
      if(RM){ el.textContent = target.toLocaleString(); return; }
      function step(ts){ if(!t0) t0 = ts; var p = Math.min((ts - t0)/dur, 1); var eased = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(target * eased).toLocaleString(); if(p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    });
    $$('.rail__i', rail).forEach(function(el, i){ setTimeout(function(){ el.classList.add('lit'); }, i*140); });
    $$('.meter', rail).forEach(function(m){ m.classList.add('lit'); });
  }
  if('IntersectionObserver' in window){ var io2 = new IntersectionObserver(function(e){ if(e[0].isIntersecting){ run(); io2.disconnect(); } }, {threshold:.3}); io2.observe(rail); } else run();
});
/* meters outside rails */
if('IntersectionObserver' in window){
  var io3 = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('lit'); io3.unobserve(e.target); } }); }, {threshold:.3});
  $$('.meter').forEach(function(m){ io3.observe(m); });
} else $$('.meter').forEach(function(m){ m.classList.add('lit'); });

/* ---------- marquees ---------- */
$$('[data-marquee]').forEach(function(t){ if(!t.dataset.doubled){ t.innerHTML += t.innerHTML; t.dataset.doubled='1'; } });

/* ---------- scrollers ---------- */
$$('[data-scroller]').forEach(function(sc){
  var id = sc.getAttribute('data-scroller');
  var prev = $('[data-prev="'+id+'"]'), next = $('[data-next="'+id+'"]');
  function page(dir){ var card = sc.querySelector('.proj,.card,.stg'); var step = card ? card.getBoundingClientRect().width + 16 : 320; sc.scrollBy({left: dir*step*2, behavior: RM ? 'auto' : 'smooth'}); }
  if(prev) prev.addEventListener('click', function(){ page(-1); });
  if(next) next.addEventListener('click', function(){ page(1); });
});

/* ============================================================
   CART — localStorage. In Shopify this is /cart.js + /cart/add.js
   ============================================================ */
var CART={items:[],item_count:0,total_price:0}, cartD=$('#cartDrawer'), lastCartFocus=null;
var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
function escapeHTML(v){return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
async function api(path,body){
 var r=await fetch(base+path,{method:body?'POST':'GET',headers:body?{'Content-Type':'application/json'}:{},body:body?JSON.stringify(body):undefined});
 var data=await r.json();if(!r.ok)throw new Error(data.description||data.message||'Unable to update cart.');return data;
}
async function renderCart(){
 try{CART=await api('cart.js');}catch(e){toast(e.message);return;}
 $$('[data-cart-count]').forEach(function(el){el.textContent=CART.item_count;el.style.display=CART.item_count?'':'none';});
 var box=$('#cartItems');if(!box)return;
 box.innerHTML=CART.items.length?CART.items.map(function(i,idx){
  return '<div class="ci"><div class="ci__img">'+(i.image?'<img src="'+escapeHTML(i.image)+'" alt="">':'')+'</div><div><h4><a href="'+escapeHTML(i.url)+'">'+escapeHTML(i.product_title)+'</a></h4>'+(i.variant_title?'<small>'+escapeHTML(i.variant_title)+'</small>':'')+'<div class="qty"><button type="button" data-cq="'+idx+'" data-d="-1" aria-label="Decrease">−</button><input type="number" value="'+i.quantity+'" min="0" data-cqi="'+idx+'" aria-label="Quantity"><button type="button" data-cq="'+idx+'" data-d="1" aria-label="Increase">+</button></div></div><div><div class="ci__p">'+money(i.final_line_price/100)+'</div><button type="button" class="ci__rm" data-crm="'+idx+'">Remove</button></div></div>';
 }).join(''):'<div class="cartd__empty"><p>Your cart is empty.</p><a class="btn btn--sm mt15" href="/collections/all">Shop everything</a></div>';
 var total=$('#cartTotal');if(total)total.textContent=money(CART.total_price/100);
 var checkout=$('#cartCheckout');if(checkout)checkout.disabled=!CART.item_count;
}
async function addToCart(item){
 try{await api('cart/add.js',{items:[{id:Number(item.id),quantity:Math.max(1,Number(item.qty)||1)}]});await renderCart();openCart();toast('Added to cart');}
 catch(e){toast(e.message);throw e;}
}
async function setQty(idx,q){var item=CART.items[idx];if(!item)return;try{await api('cart/change.js',{id:item.key,quantity:Math.max(0,Number(q)||0)});await renderCart();}catch(e){toast(e.message);}}
document.addEventListener('click',function(e){
 var b=e.target.closest('[data-cq]');if(b){var n=+b.dataset.cq;setQty(n,CART.items[n].quantity+(+b.dataset.d));return;}
 var r=e.target.closest('[data-crm]');if(r){setQty(+r.dataset.crm,0);return;}
 var a=e.target.closest('[data-add]');if(a){e.preventDefault();a.disabled=true;addToCart({id:a.dataset.add,qty:1}).catch(function(){}).finally(function(){a.disabled=false;});}
});
document.addEventListener('change',function(e){var i=e.target.closest('[data-cqi]');if(i)setQty(+i.dataset.cqi,i.value);});
function openCart(){if(!cartD)return;lastCartFocus=document.activeElement;renderCart();cartD.classList.add('is-open');cartD.removeAttribute('inert');cartD.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';var close=cartD.querySelector('[data-close-cart].cartd__x');if(close)close.focus();}
function closeCart(){if(!cartD||!cartD.classList.contains('is-open'))return;cartD.classList.remove('is-open');cartD.setAttribute('inert','');cartD.setAttribute('aria-hidden','true');if(!(links&&links.classList.contains('is-open')))document.body.style.overflow='';if(lastCartFocus)lastCartFocus.focus();}
$$('[data-open-cart]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();openCart();});});
$$('[data-close-cart]').forEach(function(b){b.addEventListener('click',closeCart);});
document.addEventListener('keydown',function(e){if(e.key!=='Tab')return;var overlay=cartD&&cartD.classList.contains('is-open')?cartD:srch&&srch.classList.contains('is-open')?srch:null;if(!overlay)return;var controls=$$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]',overlay).filter(function(el){return el.getClientRects().length;});if(!controls.length)return;var first=controls[0],last=controls[controls.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}});
var toastEl=$('#toast'),toastT;
function toast(msg){if(!toastEl)return;toastEl.textContent=msg;toastEl.classList.add('is-on');clearTimeout(toastT);toastT=setTimeout(function(){toastEl.classList.remove('is-on');},3500);}
renderCart();
var coBtn=$('#cartCheckout');if(coBtn)coBtn.addEventListener('click',function(){if(CART.item_count)window.location.assign(base+'checkout');});
/* ============================================================
   SEARCH — client-side index (Shopify: predictive search API)
   ============================================================ */
var srch = $('#search'), srchIn = $('#searchInput'), srchRes = $('#searchRes'), INDEX = null, lastSearchFocus = null;
function openSearch(){ if(!srch) return; lastSearchFocus = document.activeElement; srch.classList.add('is-open'); srch.removeAttribute('inert');srch.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; setTimeout(function(){ srchIn.focus(); }, 30);
  if(!INDEX){ if(window.BP_INDEX){ INDEX = window.BP_INDEX; } else { var sc = document.createElement('script'); sc.src = window.BP_SEARCH_INDEX_URL; sc.onload = function(){ INDEX = window.BP_INDEX || []; if(srchIn.value) doSearch(srchIn.value); }; sc.onerror = function(){ INDEX = []; }; document.head.appendChild(sc); } } }
function closeSearch(){ if(!srch || !srch.classList.contains('is-open')) return; srch.classList.remove('is-open'); srch.setAttribute('inert','');srch.setAttribute('aria-hidden','true'); if(!(links && links.classList.contains('is-open'))) document.body.style.overflow=''; if(lastSearchFocus) lastSearchFocus.focus(); }
$$('[data-open-search]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openSearch(); }); });
$$('[data-close-search]').forEach(function(b){ b.addEventListener('click', closeSearch); });
function doSearch(q){
  if(!INDEX) return; q = q.trim().toLowerCase();
  if(!q){ srchRes.innerHTML=''; return; }
  var terms = q.split(/\s+/);
  var hits = INDEX.map(function(it){
    var hay = (it.t + ' ' + (it.k||'') + ' ' + (it.x||'')).toLowerCase(); var score = 0;
    terms.forEach(function(t){ if(it.t.toLowerCase().indexOf(t) >= 0) score += 3; else if(hay.indexOf(t) >= 0) score += 1; });
    return {it:it, s:score};
  }).filter(function(h){ return h.s > 0; }).sort(function(a,b){ return b.s - a.s; }).slice(0, 24);
  srchRes.innerHTML = hits.length ? hits.map(function(h){ var it = h.it; return '<a href="'+it.u+'"><img src="'+(it.i ? (it.i.indexOf('http')===0 ? it.i : ROOT+it.i) : window.BP_LOGO_URL)+'" alt=""><span><span class="k">'+escapeHTML(it.k)+'</span><b>'+escapeHTML(it.t)+'</b>'+(it.p?'<small style="color:var(--bp-mute)">'+it.p+'</small>':'')+'</span></a>'; }).join('')
    : '<p class="srch__hint">No results for “'+escapeHTML(q)+'”. Try a vehicle (GT350), a part (supercharger) or a build (Hellcat).</p>';
}
if(srchIn) srchIn.addEventListener('input', function(){ doSearch(srchIn.value); });
$$('[data-sq]').forEach(function(b){ b.addEventListener('click', function(){ srchIn.value = b.getAttribute('data-sq'); doSearch(srchIn.value); }); });
if(srch) srch.addEventListener('click', function(e){ if(e.target === srch) closeSearch(); });
document.addEventListener('keydown', function(e){ if((e.metaKey||e.ctrlKey) && e.key.toLowerCase()==='k'){ e.preventDefault(); openSearch(); } });

/* ============================================================
   PRODUCT PAGE — variants (Shopify: product.variants JSON)
   ============================================================ */
var productForm=$('#bp-product-form'),variantSelect=$('#bp-variant'),priceEl=$('#pPrice'),stockEl=$('#pStock'),addBtn=$('#pAdd'),qtyIn=$('#pQty'),mainImg=$('#pImg');
function refreshVariant(){if(!variantSelect)return;var option=variantSelect.selectedOptions[0];var available=option.dataset.available==='true';if(priceEl)priceEl.textContent=option.dataset.price;if(stockEl)stockEl.textContent=available?'Available':'Sold out';if(addBtn){addBtn.disabled=!available;addBtn.querySelector('span').textContent=available?'Add to cart':'Sold out';}var u=new URL(window.location);u.searchParams.set('variant',option.value);history.replaceState(null,'',u);}
if(variantSelect)variantSelect.addEventListener('change',refreshVariant);
$$('[data-quantity]').forEach(function(b){b.addEventListener('click',function(){qtyIn.value=Math.max(1,(Number(qtyIn.value)||1)+Number(b.dataset.quantity));});});
if(productForm)productForm.addEventListener('submit',async function(e){
 e.preventDefault();var error=$('#bp-product-error');if(error)error.textContent='';addBtn.disabled=true;
 try{await addToCart({id:variantSelect.value,qty:qtyIn.value});}catch(e){if(error)error.textContent=e.message;}
 finally{refreshVariant();}
});
$$('.pdp__thumbs button').forEach(function(b){b.addEventListener('click',function(){if(mainImg){mainImg.src=b.dataset.src;mainImg.removeAttribute('srcset');}$$('.pdp__thumbs button').forEach(function(x){x.classList.remove('is-on');});b.classList.add('is-on');});});
/* ---------- filters toggle (mobile) ---------- */
$$('[data-filters]').forEach(function(b){ b.addEventListener('click', function(){ var f = $('#filters'); if(f) f.classList.toggle('is-open'); }); });
/* ---------- collection sort (client-side demo) ---------- */
var sortSel = $('#sortSel');
if(sortSel){
  sortSel.addEventListener('change', function(){
    var grid = $('#prodGrid'); if(!grid) return;
    var cards = $$('.card', grid);
    var v = sortSel.value;
    cards.sort(function(a,b){
      var pa = parseFloat(a.getAttribute('data-price')||0), pb = parseFloat(b.getAttribute('data-price')||0);
      var ta = a.getAttribute('data-title')||'', tb = b.getAttribute('data-title')||'';
      if(v==='price-asc') return pa-pb; if(v==='price-desc') return pb-pa; if(v==='title') return ta.localeCompare(tb); return (+a.getAttribute('data-i'))-(+b.getAttribute('data-i'));
    });
    cards.forEach(function(c){ grid.appendChild(c); });
  });
}
/* ---------- collection filter (client-side, by data-tags) ---------- */
$$('[data-ftag]').forEach(function(cb){
  cb.addEventListener('change', function(){
    var on = $$('[data-ftag]:checked').map(function(c){ return c.getAttribute('data-ftag'); });
    var grid = $('#prodGrid'); if(!grid) return; var shown = 0;
    $$('.card', grid).forEach(function(c){ var tags = (c.getAttribute('data-tags')||'').split(','); var ok = !on.length || on.every(function(t){ return tags.indexOf(t) >= 0; }); c.style.display = ok ? '' : 'none'; if(ok) shown++; });
    var cnt = $('#prodCount'); if(cnt) cnt.textContent = shown;
  });
});
/* ---------- stage tabs (packages hub) ---------- */
$$('[data-tab]').forEach(function(b){
  b.addEventListener('click', function(){
    var g = b.closest('[data-tabs]'); var t = b.getAttribute('data-tab');
    $$('[data-tab]', g).forEach(function(x){ x.classList.toggle('is-on', x===b); });
    $$('[data-pane]', g).forEach(function(p){ p.style.display = (t==='all' || p.getAttribute('data-pane')===t) ? '' : 'none'; });
  });
});
/* ---------- lightbox (very small) ---------- */
$$('[data-lb]').forEach(function(a){
  a.addEventListener('click', function(e){
    e.preventDefault();
    var lb = document.createElement('div');
    lb.style.cssText='position:fixed;inset:0;z-index:200;background:rgba(0,0,0,.94);display:grid;place-items:center;padding:2rem;cursor:zoom-out';
    lb.innerHTML='<img src="'+a.getAttribute('href')+'" alt="" style="max-width:100%;max-height:100%;object-fit:contain;border-radius:4px">';
    lb.addEventListener('click', function(){ lb.remove(); });
    document.body.appendChild(lb);
  });
});
})();
